import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import DefaultLayout from '../pages/_layouts/default';
import LoggedLayout from '../pages/_layouts/logged';

const propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  path: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool,
  exact: PropTypes.bool,
};

const defaultProps = {
  exact: false,
  isPrivate: false,
};

const RouteWrapper = ({ component: Component, path, exact, isPrivate }) => {
  const { isLoggedIn } = useAuth();

  if (isPrivate) {
    if (!isLoggedIn) {
      return <Redirect to="/" />;
    }

    return (
      <Route
        path={path}
        exact={exact}
        render={props => (
          <LoggedLayout>
            <Component {...props} />
          </LoggedLayout>
        )}
      />
    );
  }

  if (isLoggedIn) {
    return <Redirect to="/profile" />;
  }

  return (
    <Route
      path={path}
      exact={exact}
      render={props => (
        <DefaultLayout>
          <Component {...props} />
        </DefaultLayout>
      )}
    />
  );
};

RouteWrapper.propTypes = propTypes;
RouteWrapper.defaultProps = defaultProps;

export default RouteWrapper;
